import { getRouteApi } from "@tanstack/react-router"
import { memo } from "react"

import { ViewContainer } from "../../components/Containers/ViewContainer"
import { ProjectTimeline } from "../../components/ProjectTimeline/ProjectTimeline"

const routeApi = getRouteApi("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/timeline")

export const ProjectDashboardView = memo(() => {
	const { projectId } = routeApi.useParams()

	return (
		<ViewContainer maxWidth="6xl">
			<div className="flex size-full flex-col gap-4">
				<ProjectTimeline projectId={projectId} />
			</div>
		</ViewContainer>
	)
})
ProjectDashboardView.displayName = "ProjectDashboardView"
